import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initTracking } from './tracking';
import { trackAppOpen } from './analytics';

// First-party link attribution. Called HERE and not from App.js on purpose: it
// reads window.location and needs no router at all, index.js runs exactly once,
// and routing is the one part of this app that is expensive to get wrong. It is
// total — it swallows its own errors and can never keep the app from rendering.
initTracking();

// Product analytics (product-analytics/ROUND2-EVENT-DICTIONARY.md). Same place as
// initTracking and for the same reasons — index.js runs once per document, before
// the router exists. A SEPARATE system: this one is identified by the JWT and
// no-ops entirely when signed out, where initTracking identifies an anonymous
// visitor. It is total; it cannot keep the app from rendering.
trackAppOpen();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
